import { MepEmissionsByMonth, MepDashboardRequest, MepEmissionsByMonthInsightsInformation, EmissionTypeCategoryEnum } from "../../../../../../../../models/mep/mep.models";
import { MepService } from "../../../../../../../../services/mep/mep.service";
import { computedFrom } from "aurelia-binding";
import { MepEmissionsByMonthChartViewModel } from "./mep-emissions-by-month-chart-vm";
import {MepDashboardFilter} from "../mep-dashboard-filter/mep-dashboard-filter";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { useView } from "aurelia-framework";

@useView('views/pages/modules/mep/tabs/mep-dashboard/partials/mep-emissions-by-month/mep-emissions-by-month.html')
export class MepEmissionsByMonthViewModel {
    emissionsByMonth: MepEmissionsByMonth[];
    isEmissionsByMonthLoading: boolean = false;
    ghgEmissionsChartViewModel: MepEmissionsByMonthChartViewModel;
    pollutantsEmissionsChartViewModel: MepEmissionsByMonthChartViewModel;
    insightsInformation: MepEmissionsByMonthInsightsInformation;
    isMepTrial: boolean = false;
    isGhgEmissions: boolean = true;
    ghgEmissionsItems: MepEmissionsByMonth[];
    criteriaPollutantsItems: MepEmissionsByMonth[];

    @computedFrom('isGhgEmissions', 'ghgEmissionsChartViewModel', 'pollutantsEmissionsChartViewModel')
    public get emissionsChartViewModel(): MepEmissionsByMonthChartViewModel {
        return this.isGhgEmissions ? this.ghgEmissionsChartViewModel : this.pollutantsEmissionsChartViewModel;
    }

    @computedFrom('isGhgEmissions', 'ghgEmissionsChartViewModel', 'pollutantsEmissionsChartViewModel')
    public get emissionsChartViewModels(): MepEmissionsByMonthChartViewModel[] {
        return [this.ghgEmissionsChartViewModel, this.pollutantsEmissionsChartViewModel];
    }

    constructor(private filterViewModel: MepDashboardFilter, private mepService: MepService, isMepTrial: boolean, private configService: ConfigService) {
        this.isMepTrial = isMepTrial;
    }

    /**
     * Get emissions units
     */
    @computedFrom('isGhgEmissions')
    get getUnits(){
        return this.isGhgEmissions ? 'GHG Emissions (tCO<sub>2</sub>e_100yr)':'Emissions (tonnes)';
    }

    getInsightsInformationMonths(): string {
        if (this.insightsInformation && this.insightsInformation.months)
            return this.insightsInformation.months.join(' and ');
        return ' ';
    }

    getEmissionsByMonth(request: MepDashboardRequest) {
        return new Promise<string>((resolve, reject) => {
            this.isEmissionsByMonthLoading = true;
            
            if (this.filterViewModel.emissionTypeCategoryIds.length == 1) {
                this.isGhgEmissions = this.filterViewModel.emissionTypeCategoryIds[0] == EmissionTypeCategoryEnum.GhgEmissions;
            }
            this.mepService.getMepEmissionsByMonth(request).then(response => {
                this.isEmissionsByMonthLoading = false;
                if (!response.hasError) {
                    this.insightsInformation = response.insightsInformation;
                    this.emissionsByMonth = response.emissionsByMonth;
                    this.ghgEmissionsItems = this.emissionsByMonth.filter(x => x.emissionTypeCategoryId == EmissionTypeCategoryEnum.GhgEmissions);
                    this.criteriaPollutantsItems = this.emissionsByMonth.filter(x => x.emissionTypeCategoryId == EmissionTypeCategoryEnum.CriteriaPollutants);
                    this.ghgEmissionsChartViewModel = new MepEmissionsByMonthChartViewModel("chartghgdiv", request.year, this.ghgEmissionsItems, this.configService);
                    this.pollutantsEmissionsChartViewModel = new MepEmissionsByMonthChartViewModel("chartpollutantsdiv", request.year, this.criteriaPollutantsItems, this.configService);
                    resolve(null);
                }
                else {
                    reject("MEP Emissions by Month - Error retrieving the emissions by month!");
                }
            }).catch(() => {
                this.isEmissionsByMonthLoading = false;
                reject("MEP Emissions by Month - Error retrieving the emissions by month!");
            });
        });
    }

    clearData() {
        this.emissionsByMonth = null;
        this.ghgEmissionsChartViewModel = null;
        this.pollutantsEmissionsChartViewModel = null;
    }

    setIsGhgEmission(value: boolean) {
        this.isGhgEmissions = value;
    }
}